import React from 'react'
import { connect } from 'react-redux'
import i18n from 'support/i18n'
import { applyFilterService, applySearchService } from 'services/ideas'
import { getChallengeById, getChallengeVisitorsById } from 'services/challenges'
import { getActiveOrganizations } from 'services/organizations'
import { getActiveTypes } from 'services/types'
import Navigation from 'support/navigation'
import { FIRST_LIMIT_CONSTANT } from 'common_constants/Ideas'
import {
  showPopupDialog,
  showPopupSuccessSnackbar,
  showPopupErrorSnackbar,
} from 'support/popup_dialogs'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import ConfirmDeleteModal from './components/dialogs/ConfirmDeleteContainer'
import ConfirmFinishModal from './components/dialogs/ConfirmFinishContainer'
import View from './View'
import { getIdeaTemplatelist, getScorecardTemplatelist } from 'services/innovate/templates'
import { getInnovateChallenge, getInnovateChallengeActiveTypes } from 'services/innovate/challenge'
import { getGroups } from 'services/challenge_steps'
//import ImageViewDialog from '../form/components/preview_launch/components/dialogs/ImageViewDialog/View'

const mapStateToProps = state => {
  return {
    challenge: state.data.challenge.challengeById,
    ideasChallenge: state.data.challenge.challengeById.ideas,
    totalIdeasChallenge: state.data.challenge.totalIdeas,
    challengesLoading: state.data.challenge.challengesLoading,
    challengeIdeasLoading: state.data.challenge.challengeIdeasLoading,
    hasMoreIdeasToLoad: state.data.idea.hasMore,
    isOrganizationsActive: state.data.domain.domainConfiguration.isOrganizationsActive,
    isTypesActive: state.data.domain.domainConfiguration.isTypesActive,
    organizations: state.data.domain.organizations,
    folderOrganizations: state.data.domain.folderOrganizations,
    organizationsName: state.data.domain.domainConfiguration.organizationsName,
    ideaStatusStepper: state.data.domain.domainConfiguration.ideaStatusStepper,
    types: state.data.domain.types,
    isAdmin: state.data.user.admin,
    isInnovator: state.data.user.isInnovator,
    isEvaluator: state.data.user.evaluator,
    isLocalAdmin: state.data.user.localAdmin,
    sameOrigin: state.data.user.countryId === state.data.challenge.challengeById.origin,
    countryId: state.data.user.countryId ,
    origin:  state.data.challenge.challengeById.origin,
    submitByChallengeUserEmail: state.data.user.userEmail,
    submitByChallengeUserName: state.data.user.userName,
    submitByChallengeUserLastName: state.data.user.userLastName,
    listScorecardTemplate:state.data.templates.listScorecardTemplate,
    listIdeaTemplate:state.data.templates.listIdeaTemplate,
    innovateCategoryTypes:state.data.InnovateChallenge.innovateCategoryTypes,
    listCommunitesChallenge:state.data.InnovateChallenge.listInnovateCommunitesChallenge,
    loginUserEmail: state.data.user.userEmail,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {

    applyFilter: (
      challenge,
      organizations,
      status,
      types,
      limit = FIRST_LIMIT_CONSTANT,
      offset = 0,
    ) => {
      dispatch(applyFilterService({ challenge, organizations, status, types, limit, offset }))
    },
    applySearch: search => {
      dispatch(applySearchService({ search, challengeId: ownProps.match.params.id }))
    },
    getChallengeById: (id, limit = 2, offset = 0) => {
      dispatch(getChallengeById(id, limit, offset))
    },
    getOrganization: () => {
      dispatch(getActiveOrganizations())
    },
    getTypes: () => {
      dispatch(getActiveTypes())
    },
    navigateToIdeaDetail: id => {
      dispatch(Navigation.navigateToIdea(id))
    },
    navigateToNewIdea: id => {
      dispatch(Navigation.navigateToNewIdea(id))
    },
    navigateToAllChallenges: id => {
      dispatch(Navigation.navigateToChallenges())
    },
    onEditClick: id => {
      dispatch(Navigation.navigateToChallengeForm(id))
    },
    navigateToUserProfile: userEmail => {
      Navigation.navigateToUserProfile(userEmail)
    },
    onDeleteClick: id => {
      showPopupDialog(<ConfirmDeleteModal id={id} />, dispatch)
    },
    onFinishClick: id => {
      showPopupDialog(<ConfirmFinishModal id={id} />, dispatch)
    },
    onVisitorsClick: id => {
      const onSuccess = () => {
        showPopupSuccessSnackbar(i18n.t('CHALLENGES.DOWNLOAD_CHALLENGE_VISITORS_OK'), dispatch)
      }
      const onFailure = () => {
        showPopupErrorSnackbar(i18n.t('CHALLENGES.DOWNLOAD_CHALLENGE_VISITORS_KO'), dispatch)
      }
      dispatch(getChallengeVisitorsById(id, onSuccess, onFailure))
    },
    // navigateToIdeaDetail: id => {
    //   dispatch(Navigation.navigateToIdea(id))
    // },
    onEditClickInnovate: id => {
      dispatch(Navigation.navigateToInnovateChallengeForm(id))
    },
    getScorecardTemplatelistFn: ()=>{
      dispatch(getScorecardTemplatelist())
    },
    getInnovateChallengeFn: (challengeKeyId)=>{
      dispatch(getInnovateChallenge(challengeKeyId))
    },
    getCommunitesAsGroup : ()=> dispatch(getGroups()),
    getIdeaTemplatelistFn: ()=>{
      dispatch(getIdeaTemplatelist())
    },
    getInnovateChallengeActiveTypesFn: () => {
      dispatch(getInnovateChallengeActiveTypes())
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
